module.exports = require('../_components/@alicd/next-accordion/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/accordion/index.js
// module id = 518
// module chunks = 0